import axios from 'axios'
import { Message } from 'element-ui'
import store from '../store'
import { getNewToken, removeNewToken, setNewToken } from '@/utils/auth'
import { refreshToken } from '@/api/login'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 10000, // 请求超时时间
  cache: false
})
// request拦截器
service.interceptors.request.use(config => {
  if (store.getters.token) {
    config.headers['Access-Protection'] = getNewToken()
  }
  return config
},
error => {
  Message({ showClose: true, center: true, message: error.message, type: 'error', duration: 3 * 1000 })
})
// 是否正在刷新的标记
let isRefreshing = false
// 重试队列，每一项将是一个待执行的函数形式
let requests = []
service.interceptors.response.use(response => {
  const res = response.data
  if (res.code === 409 || res.code === 503 || res.code === 403 || res.code === 404 || res.code === 400 || res.code === 11111 || res.code === 11199) {
    // 出错信息捕捉
    if (res.message !== '' && res.message !== null && res.message !== undefined) {
      Message({ showClose: true, center: true, message: res.message, type: 'error', duration: 3 * 1000 })
    }
    if (res.msg !== '' && res.msg !== null && res.msg !== undefined) {
      Message({ showClose: true, center: true, message: res.msg, type: 'error', duration: 3 * 1000 })
    }
    if (res.data === null) {
      Message({ showClose: true, center: true, message: '出错啦', type: 'error', duration: 3 * 1000 })
    }
  }
  if (res.code === 500) {
    Message({ showClose: true, center: true, message: '服务器出差了，请稍等哦！', type: 'error', duration: 3 * 1000 })
  }
  return response
}, error => {
  if (error.response === undefined) {
    Message({ showClose: true, center: true, message: '服务器出差了，请稍等哦！', type: 'error', duration: 3 * 1000 })
  }
  const res = error.response.data
  const status = error.response.status
  if (status === 401) {
    removeNewToken()
    const config = error.config
    if (!isRefreshing) {
      isRefreshing = true
      return refreshToken().then(res1 => {
        setNewToken(res1.data.data.token)
        requests.forEach(cb => cb())
        requests = []
        return service(config)
      }).catch(res => {
        console.error('refreshtoken error =>', res)
        localStorage.clear()
        sessionStorage.clear()
        window.location.href = '#/login'
      }).finally(() => {
        isRefreshing = false
      })
    } else {
      // 正在刷新token，将返回一个未执行resolve的promise
      return new Promise((resolve) => {
        // 将resolve放进队列，用一个函数形式来保存，等token刷新后直接执行
        requests.push(() => {
          resolve(service(config))
        })
      })
    }
  }
  if (status === 400) {
    if (res.message !== '' && res.message !== null) {
      Message({ showClose: true, center: true, message: res.message, type: 'error', duration: 3 * 1000 })
    } else {
      Message({ showClose: true, center: true, message: '请求参数错误！', type: 'error', duration: 3 * 1000 })
    }
  }
  if (status === 404) {
    if (res.message !== '' && res.message !== null) {
      Message({ showClose: true, center: true, message: res.message, type: 'error', duration: 3 * 1000 })
    } else {
      Message({ showClose: true, center: true, message: '出错啦！', type: 'error', duration: 3 * 1000 })
    }
  }
  if (status === 500) {
    Message({ showClose: true, center: true, message: '服务器出差了，请稍等哦！', type: 'error', duration: 3 * 1000 })
  }
  return Promise.reject(error)
})

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js